module.exports = __webpack_public_path__ + "img/ka_logo.0a9df474.jpg";